import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Button, Card, CardActions, CardContent, CardHeader, Checkbox, FormControlLabel, InputAdornment, TextField,
} from '@mui/material';
import { AppFormLayout, ImplicitSubmit } from '@shared';
import { ta } from 'utils';

const propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,

  values: PropTypes.shape({
    uid: PropTypes.string,
    user_attributes: PropTypes.object,
  }),
  errors: PropTypes.object.isRequired,
  secondaryFooterActions: PropTypes.array,
  showActive: PropTypes.bool, // Only when editing: a new courier always starts active
}

const CourierForm = ({
  handleSubmit, values, errors, handleChange, ...otherProps
}) => (
  <Card>
    <CardHeader
      title={ `Editando ${I18n.t("activerecord.models.courier.one")}` }
      titleTypographyProps={{ variant: 'h6' }}
    />
    <CardContent>
    <form onSubmit={(event) => { event.preventDefault(); handleSubmit(); }} >
      {/* user name */}
      <AppFormLayout>
        <TextField
          fullWidth
          InputLabelProps={{ shrink: true }}
          id="user_attributes.first_name"
          label={ta("general.name")}
          placeholder={I18n.t("form.placeholder.name")}
          value={values.user_attributes.first_name}
          onChange={(event) => handleChange(event.target.value, "user_attributes.first_name")}
          error={!!errors["user.first_name"]}
          helperText={errors["user.first_name"]}
        />
        <TextField
          fullWidth
          InputLabelProps={{ shrink: true }}
          id="phone"
          type='tel'
          InputProps={{ startAdornment: <InputAdornment position="start">+506</InputAdornment> }}
          label={ta("courier.phone")}
          placeholder='12345678'
          value={values.phone}
          onChange={(event) => handleChange(event.target.value, "phone")}
          error={!!errors.phone}
          helperText={errors.phone}
        />
        <TextField
          fullWidth
          InputLabelProps={{ shrink: true }}
          id="national_id"
          label={ta("courier.national_id")}
          placeholder="---"
          value={values.national_id}
          onChange={(event) => handleChange(event.target.value, "national_id")}
          error={!!errors.national_id}
          helperText={errors.national_id}
        />
        <TextField
          fullWidth
          InputLabelProps={{ shrink: true }}
          id="uid"
          label={ta("courier.uid")}
          placeholder="xxe3"
          inputProps={{ minLength: 4, maxLength: 4 }}
          value={values.uid}
          onChange={(event) => handleChange(event.target.value, "uid")}
          error={!!errors.uid}
          helperText={errors.uid}
        />
        { otherProps.showActive &&
          <FormControlLabel
            label={ta("courier.active")}
            control={
              <Checkbox
                id="active"
                checked={!!values.active}
                onChange={(event) => handleChange(event.target.checked, "active")}
              />
            }
          />
        }
      </AppFormLayout>
      <ImplicitSubmit />
    </form>
    </CardContent>

    <CardActions sx={{ justifyContent: 'flex-end' }}>
      { (otherProps.secondaryFooterActions || []).map((action, index) => (
        <Button key={index} variant="outlined" color="inherit" href={action.url} onClick={action.onAction}>
          { action.content }
        </Button>
      ))}
      <Button variant="contained" onClick={() => handleSubmit()}>
        { I18n.t("actions.save") }
      </Button>
    </CardActions>
  </Card>
)

CourierForm.propTypes = propTypes;

export default CourierForm;
